export type ExcludeOptions =
  | "today"
  | "yesterday"
  | "last7Days"
  | "last30Days"
  | "last90Days"
  | "last180Days"
  | "lastMonth"
  | "lastYear"
  | "yearToDate"
  | "custom"
  | "alltime";

export interface DatesState {
  startDateState: string;
  endDateState: string;
}

export interface DatesInputState {
  startDateState: string;
  startDateValid: boolean;
  endDateState: string;
  endDateValid: boolean;
  highlightInvalid: boolean;
}

export const DATE_FORMAT = "YYYY-MM-DD";
export const START_DATE_INPUT = "START_DATE_INPUT";
export const END_DATE_INPUT = "END_DATE_INPUT";

export const TIME_INTERVALS = {
  today: "today",
  yesterday: "yesterday",
  last7Days: "last7Days",
  last30Days: "last30Days",
  last90Days: "last90Days",
  last180Days: "last180Days",
  lastMonth: "lastMonth",
  lastYear: "lastYear",
  yearToDate: "yearToDate",
  custom: "custom",
  alltime: "alltime",
} as const;

export const DROPDOWN_OPTIONS = {
  [TIME_INTERVALS.alltime]: "All time",
  [TIME_INTERVALS.today]: "Today",
  [TIME_INTERVALS.yesterday]: "Yesterday",
  [TIME_INTERVALS.last7Days]: "Last 7 days",
  [TIME_INTERVALS.last30Days]: "Last 30 days",
  [TIME_INTERVALS.last90Days]: "Last 90 days",
  [TIME_INTERVALS.last180Days]: "Last 180 days",
  [TIME_INTERVALS.lastMonth]: "Last month",
  [TIME_INTERVALS.lastYear]: "Last year",
  [TIME_INTERVALS.yearToDate]: "Year to date",
  [TIME_INTERVALS.custom]: "Custom",
} as const;
